import { isNullOrEmpty } from "./string";

export function isEmailValid(email: string): boolean {
    return !isNullOrEmpty(email) &&
        email.includes('@') &&
        !email.includes(' ') &&
        !email.startsWith('@') &&
        !email.endsWith('@');
}
